import { render } from "./recordingTranslation.vue?vue&type=template&id=53ce9b51&ts=true"
import script from "./recordingTranslation.vue?vue&type=script&lang=ts"
export * from "./recordingTranslation.vue?vue&type=script&lang=ts"

import "./recordingTranslation.vue?vue&type=style&index=0&id=53ce9b51&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__